import { render } from "./editcategory.vue?vue&type=template&id=560990b8&scoped=true"
import script from "./editcategory.vue?vue&type=script&lang=js"
export * from "./editcategory.vue?vue&type=script&lang=js"

import "./editcategory.vue?vue&type=style&index=0&id=560990b8&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560990b8"]])

export default __exports__